// components/StockInfo.tsx
import React from "react";
import Row from "@components/row";
import Fields from "@components/fields";
import FieldWrapper from "@components/wrapper/field-wrapper";
import Typography from "@components/typography";
import DateTimePicker from "@components/fields/datetime";

interface StockInfoProps {
  values: any;
}

export const StockInfo: React.FC<StockInfoProps> = ({ values }) => {
  const stockTypeOptions = [
    { id: "unlimited", key: "Unlimited" },
    { id: "limited", key: "Limited" },
    { id: "daily", key: "Daily Stock" },
  ];

  return (
    <FieldWrapper styleWrapper="width:98%">
      <Typography styleText="font-size:16px;font-weight:600;margin-bottom:10px">
        Stock And Availability
      </Typography>
      <Row styleRow="align-items:center;row-gap:10px">
        <Fields.DropDown
          name="stockType"
          label="Stock Type"
          options={stockTypeOptions}
          placeholder="Select Stock Type"
          styleInput="width:96%"
          titleAsKey="key"
          valueAsKey="id"
        />
        <Fields.Input
          disabled={values.stockType === "unlimited"}
          name="itemStock"
          label="Item Stock"
          placeholder="Enter Item Stock"
        />
        <Fields.Input
          name="purchaseLimit"
          label="Maximum Purchase Limit"
          placeholder="Enter purchase limit"
          disabled={true}
        />
      </Row>
      <br />
      <Row styleRow="align-items:center;row-gap:10px">
        <Fields.DropDown
          name="availableDuringOpening"
          label="Availability Timing"
          placeholder="Select Availability timing"
          options={[
            { id: 1, name: "During Opening Hours" },
            { id: 2, name: "Custom Timing" },
          ]}
          titleAsKey="name"
          valueAsKey="id"
          styleInput="width:96%"
        />
        <DateTimePicker
          disabled={values.availableDuringOpening === "1"}
          placeholder="Select Time"
          name="availableTimeStart"
          label="Available Time Start"
          showTimeSelect={true}
          showDateSelect={false}
          timeFormat="hh:mm aa"
          timeIntervals={15}
        />
        <DateTimePicker
          disabled={values.availableDuringOpening === "1"}
          placeholder="Select Time"
          name="availableTimeEnd"
          label="Available Time End"
          showTimeSelect={true}
          showDateSelect={false}
          timeFormat="hh:mm aa"
          timeIntervals={15}
        />
      </Row>
      <br />
      <Row styleRow="align-items:center;row-gap:10px">
        <DateTimePicker name="date" label="Expiry Date" />
        <Fields.Switch
          name="popular"
          label="Most Popular"
          styleWrapper="flex-direction:row;justify-content:space-between"
        />
        <Fields.Switch
          name="mostorder"
          label="Most Order"
          styleWrapper="flex-direction:row;justify-content:space-between"
        />
        <Fields.Switch
          name="latestarrival"
          label="Latest Arrival"
          styleWrapper="flex-direction:row;justify-content:space-between"
        />
      </Row>
    </FieldWrapper>
  );
};
